export enum SecurityGroups {
  WebSiteAdmin = 0,
  ClientAdmin = 10,
  ClientPowerUser = 20,
  LocationAdmin = 25,
  ClientStandardUser = 30,
  ClientStandardNoTransNoVoid = 34,
  ClientStandardNoTrans = 35,
  ClientStandardNoFc = 36,
  LedgerAndReports = 40,
  LedgerAndReportsPlusDAAG = 41,
  LedgerOnly = 45,
  LedgerPlusDAAG = 46,
  Reports = 50,
  TransactionAndReports = 70,
  DAGG = 80,
  Custom1 = 81,
  Custom2 = 82,
  Custom3 = 83,
  FrontDesk = 84,
  Custom4 = 85,
  None = 1000
}
